import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

const MassWhatsAppDialog = ({ open, onOpenChange, selectedCount, message, setMessage, onSend, sending }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><MessageSquare className="w-5 h-5 text-green-600" />Envio Masivo de WhatsApp</DialogTitle>
          <DialogDescription>Enviar mensaje a {selectedCount} clientes seleccionados</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Escribe tu mensaje..." rows={4} className="mt-1" />
            <p className="text-xs text-slate-500 mt-2">Variables: <code className="bg-slate-100 px-1">{'{nombre}'}</code> <code className="bg-slate-100 px-1">{'{deuda}'}</code> <code className="bg-slate-100 px-1">{'{link}'}</code></p>
          </div>
          <div className="bg-slate-50 border border-slate-200 rounded-lg p-3">
            <p className="text-sm font-medium text-slate-700 mb-2">Vista previa:</p>
            <p className="text-sm text-slate-600">{message.replace('{nombre}', 'Juan Perez').replace('{deuda}', '$10,000.00').replace('{link}', 'https://...')}</p>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">Cancelar</Button>
            <Button onClick={onSend} disabled={sending} className="flex-1 bg-green-600 hover:bg-green-700">{sending ? 'Enviando...' : `Enviar a ${selectedCount}`}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MassWhatsAppDialog;
